import { PriceChange } from './price-change';
import { Product } from './product';
import { ProductType } from './product-type';
import { TranslatedText, Translation } from './translated-text';

export class ProductCombo extends Product {
  public combo: any;

  constructor(
    id: string,
    sku: string,
    name: string | TranslatedText,
    description: string | TranslatedText,
    price: number,
    priceChanges: PriceChange[],
    order: any,
    energyInformation: string,
    imageUrl: string,
    isVisible = true,
    categoryId: string,
    isAvailable = true,
    originalImageUrl: string,
    combo: any,
    posItemId: number,
    nameTranslations?: Translation[],
    serves?: string | TranslatedText,
  ) {
    super(
      id,
      sku,
      name,
      description,
      price,
      priceChanges,
      order,
      energyInformation,
      imageUrl,
      isVisible,
      categoryId,
      isAvailable,
      originalImageUrl,
      posItemId,
      nameTranslations,
      serves,
    );

    this.combo = combo;
    this.providerData = {};

    this.type = ProductType.COMBO;
  }

  hasFilter() {
    return this.combo.filters.length > 0;
  }

  hasFilterWithIdZero() {
    return this.combo.filters.filter((comboFilter: any) => comboFilter.id === 0).length > 0;
  }
}
